/* Nukka Care V2 — animations (sans dépendance). */
(function () {
  'use strict';
  window.kReady = true;
  var root = document.documentElement;
  if (!root.classList.contains('js')) root.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Apparitions ---------- */
  function reveal() {
    var els = $$('[data-k-reveal], [data-k-clip], .k-lines');
    if (!hasIO || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    // sécurité : rien ne reste caché
    setTimeout(function () { $$('[data-k-reveal]:not(.is-in), [data-k-clip]:not(.is-in), .k-lines:not(.is-in)').forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < window.innerHeight) e.classList.add('is-in'); }); }, 2500);
  }

  /* ---------- Vidéos : chargement paresseux, lecture seulement à l'écran ---------- */
  function videos() {
    var vids = $$('video[data-k-video]');
    function load(v) {
      if (v.dataset.loaded) return;
      var src = v.getAttribute('data-src');
      if (window.innerWidth < 750 && v.getAttribute('data-src-mobile')) src = v.getAttribute('data-src-mobile');
      if (src) { v.src = src; v.load(); }
      v.dataset.loaded = '1';
    }
    function play(v) {
      load(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      if (v.hasAttribute('data-eager') && v.offsetParent !== null) play(v);
    });
    if (reduce) return;
    if (!hasIO) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) play(v); else if (v.dataset.loaded) v.pause();
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- Phrase manifeste : les mots s'allument ---------- */
  function statements() {
    $$('[data-k-words]').forEach(function (el) {
      var html = el.innerHTML;
      // <em>…</em> garde l'italique
      var out = '';
      var parts = html.split(/(<em>.*?<\/em>)/g);
      parts.forEach(function (p) {
        var isEm = /^<em>/.test(p);
        var text = p.replace(/<\/?em>/g, '');
        text.split(/(\s+)/).forEach(function (w) {
          if (!w) return;
          if (/^\s+$/.test(w)) { out += ' '; return; }
          out += '<span class="w' + (isEm ? ' em' : '') + '">' + w + '</span>';
        });
      });
      el.innerHTML = out;
      var words = $$('.w', el);
      if (reduce) { words.forEach(function (w) { w.classList.add('on'); }); return; }
      function update() {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('on', i < n); });
      }
      onScroll(update);
    });
  }

  /* ---------- Boucle de défilement partagée ---------- */
  var scrollFns = [];
  var ticking = false;
  function onScroll(fn) { scrollFns.push(fn); fn(); }
  function tick() { ticking = false; scrollFns.forEach(function (f) { f(); }); }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }, { passive: true });
  window.addEventListener('resize', function () { requestAnimationFrame(tick); });

  /* ---------- Histoire collante (zones) ---------- */
  function stories() {
    $$('[data-k-story]').forEach(function (sec) {
      var steps = $$('[data-k-step]', sec);
      var dots = $$('[data-k-dot]', sec);
      var bars = $$('[data-k-bar]', sec);
      var frame = sec.querySelector('[data-k-frame]');
      function set(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-on', j === i); });
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
        bars.forEach(function (b, j) { b.classList.toggle('is-on', j <= i); });
        if (frame) frame.setAttribute('data-active', String(i + 1));
      }
      dots.forEach(function (d, j) {
        d.addEventListener('click', function () {
          set(j);
        });
      });
      set(0);
      // survol ou clic sur une zone : met en évidence le repère (sans bloquer le défilement)
      steps.forEach(function (s, j) { s.addEventListener('mouseenter', function () { set(j); }); s.addEventListener('click', function () { set(j); }); });
    });
  }

  /* ---------- Film : la vidéo grandit en plein écran ---------- */
  function films() {
    $$('[data-k-film]').forEach(function (stage) {
      var box = stage.querySelector('.k-film__box');
      var cap = stage.querySelector('.k-film__caption');
      if (reduce) { box.style.setProperty('--s', 1); cap && cap.style.setProperty('--o', 1); return; }
      onScroll(function () {
        var r = stage.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = Math.max(0, Math.min(1, -r.top / Math.max(1, total * 0.6)));
        var start = window.innerWidth < 750 ? 0.86 : 0.7;
        box.style.setProperty('--s', (start + (1 - start) * p).toFixed(4));
        box.style.setProperty('--r', (1 - p).toFixed(3));
        if (cap) cap.style.setProperty('--o', Math.max(0, Math.min(1, (p - 0.45) / 0.4)).toFixed(3));
      });
    });
  }

  /* ---------- Barres de progression des vidéos d'étapes ---------- */
  function stepBars() {
    $$('.k-step').forEach(function (st) {
      var v = st.querySelector('video'); var bar = st.querySelector('.k-step__bar');
      if (!v || !bar) return;
      v.addEventListener('timeupdate', function () { if (v.duration) bar.style.setProperty('--p', (v.currentTime / v.duration).toFixed(3)); });
    });
  }

  /* ---------- Frise d'adaptation ---------- */
  function timelines() {
    $$('[data-k-time]').forEach(function (t) {
      var line = t.querySelector('.k-time__line'); var items = $$('.k-time__item', t);
      onScroll(function () {
        var r = t.getBoundingClientRect(); var vh = window.innerHeight;
        var p = Math.max(0, Math.min(1, (vh * 0.75 - r.top) / (r.height + vh * 0.1)));
        if (reduce) p = 1;
        line && line.style.setProperty('--p', p.toFixed(3));
        items.forEach(function (it, i) { it.classList.toggle('is-on', p >= (i + 0.35) / items.length); });
      });
    });
  }

  /* ---------- Compteurs ---------- */
  function counters() {
    var els = $$('[data-k-count]');
    function run(el) {
      var to = parseFloat(el.getAttribute('data-k-count')); var dec = (String(to).split('.')[1] || '').length;
      if (reduce) { el.textContent = to.toFixed(dec); return; }
      var t0 = null, dur = 1600;
      function step(ts) {
        if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - k, 4);
        el.textContent = (to * e).toFixed(dec); if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!hasIO) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }); }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Accordéon FAQ ---------- */
  function accordions() {
    $$('[data-k-acc]').forEach(function (acc) {
      $$('.k-acc__q', acc).forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.k-acc__item'); var open = !item.classList.contains('is-open');
          $$('.k-acc__item.is-open', acc).forEach(function (o) { if (o !== item) { o.classList.remove('is-open'); o.querySelector('.k-acc__q').setAttribute('aria-expanded', 'false'); } });
          item.classList.toggle('is-open', open); q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Parallaxe douce ---------- */
  function parallax() {
    if (reduce) return;
    var els = $$('[data-k-parallax]');
    if (!els.length) return;
    onScroll(function () {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var sp = parseFloat(el.getAttribute('data-k-parallax')) || 0.12;
        var c = (r.top + r.height / 2 - vh / 2) * -sp;
        el.style.transform = 'translate3d(0,' + c.toFixed(1) + 'px,0) scale(1.12)';
      });
    });
  }

  /* ---------- Galerie produit : vidéos jouées quand visibles ---------- */
  function galleryVideos() {
    $$('[data-nk-track]').forEach(function (track) {
      var vids = $$('video', track);
      if (!vids.length) return;
      function check() {
        vids.forEach(function (v) {
          var s = v.closest('[data-nk-slide]'); if (!s) return;
          var visible = Math.abs(s.offsetLeft - track.scrollLeft) < track.clientWidth / 2;
          if (visible) { if (!v.src && v.getAttribute('data-src')) { v.src = v.getAttribute('data-src'); } var p = v.play(); p && p.catch && p.catch(function () {}); } else v.pause();
        });
      }
      track.addEventListener('scroll', function () { requestAnimationFrame(check); }, { passive: true });
      check();
    });
  }


  /* ---------- Questionnaire ---------- */
  function quizzes() {
    $$('[data-k-quiz]').forEach(function (q) {
      if (q.dataset.ready) return; q.dataset.ready = '1';
      var steps = $$('.k-quiz__step', q), res = q.querySelector('[data-result]'), bar = q.querySelector('.k-quiz__bar i');
      var data = {}; try { data = JSON.parse(q.querySelector('[data-k-quiz-data]').textContent); } catch (e) {}
      var a = {}, i = 0;
      function show(n) {
        steps.forEach(function (s, j) { s.classList.toggle('is-on', j === n); });
        if (bar) bar.style.transform = 'scaleX(' + (Math.min(n, steps.length) / steps.length) + ')';
      }
      var TXT = {
        nuque: "Son bord cervical arrondi vient se placer sous la nuque et la soutient toute la nuit, au lieu de la laisser dans le vide.",
        epaules: "Ses ailes plus hautes comblent l'espace entre l'oreille et l'épaule, et les échancrures laissent sa place à l'épaule.",
        bras: "Les échancrures latérales laissent de la place au bras glissé sous l'oreiller, sans écraser l'épaule.",
        oreiller: "C'est un bloc de mousse à mémoire de forme d'une seule pièce : rien ne se tasse dans les coins au fil des nuits."
      };
      var TITLE = { cote: "Le Nukka est fait pour les dormeurs sur le côté.", dos: "Le Nukka est fait pour les dormeurs sur le dos.", mix: "Le Nukka suit vos changements de position." };
      function result() {
        steps.forEach(function (s) { s.classList.remove('is-on'); });
        if (bar) bar.style.transform = 'scaleX(1)';
        var o = data[a.qui] || data.solo || {};
        var t = res.querySelector('[data-r-title]'), x = res.querySelector('[data-r-text]');
        if (a.pos === 'ventre') {
          t.textContent = "Honnêtement : le Nukka n'est pas idéal si vous dormez surtout sur le ventre.";
          x.textContent = "Sa hauteur relèverait trop la nuque. S'il vous arrive aussi de dormir sur le côté ou sur le dos une bonne partie de la nuit, il peut tout de même vous convenir.";
        } else {
          t.textContent = TITLE[a.pos] || TITLE.mix;
          x.textContent = (TXT[a.reveil] || '') + (a.qui === 'duo' ? " En Duo, le 2e oreiller vous revient bien moins cher." : a.qui === 'trio' ? " En Trio, vous obtenez le prix par oreiller le plus bas." : '');
        }
        res.querySelector('[data-r-name]').textContent = 'Notre conseil : ' + (o.name || '');
        res.querySelector('[data-r-price]').textContent = o.price || '';
        res.querySelector('[data-r-compare]').textContent = o.compare || '';
        var cta = res.querySelector('[data-r-cta]');
        cta.href = q.getAttribute('data-url') + '?offre=' + (a.qui || 'solo');
        res.hidden = false;
      }
      steps.forEach(function (s, j) {
        $$('button', s).forEach(function (b) {
          b.addEventListener('click', function () {
            a[s.getAttribute('data-q')] = b.getAttribute('data-v');
            $$('button', s).forEach(function (x) { x.classList.toggle('is-picked', x === b); });
            setTimeout(function () { if (j + 1 < steps.length) show(j + 1); else result(); }, 220);
          });
        });
      });
      q.querySelector('[data-restart]').addEventListener('click', function () { a = {}; res.hidden = true; $$('.is-picked', q).forEach(function (x) { x.classList.remove('is-picked'); }); show(0); });
      show(0);
    });
  }

  /* ---------- Formule présélectionnée par lien (?offre=solo|duo|trio) ---------- */
  function preselect() {
    var m = /[?&]offre=(solo|duo|trio)/.exec(location.search);
    if (!m) return;
    var idx = { solo: 0, duo: 1, trio: 2 }[m[1]];
    var main = document.querySelector('[data-nk-main]');
    if (!main) return;
    var inputs = $$('input[data-nk-offer]', main);
    var el = inputs[idx];
    if (el && !el.disabled) { el.checked = true; el.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  /* ---------- Compte à rebours (offre réelle, date de fin fixe) ---------- */
  function countdowns() {
    $$('[data-k-cd]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-k-cd'));
      if (isNaN(end)) { el.remove(); return; }
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      function tick() {
        var t = Math.max(0, end - Date.now());
        if (t <= 0) { el.remove(); return; }
        var s = Math.floor(t / 1000);
        el.querySelector('[data-d]').textContent = pad(Math.floor(s / 86400));
        el.querySelector('[data-h]').textContent = pad(Math.floor(s % 86400 / 3600));
        el.querySelector('[data-m]').textContent = pad(Math.floor(s % 3600 / 60));
        el.querySelector('[data-s]').textContent = pad(s % 60);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ---------- Avis : filtres + voir plus ---------- */
  function reviews() {
    $$('[data-k-reviews]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var cards = $$('.k-rv__card', sec), more = sec.querySelector('[data-more]'), shown = 6, filter = '';
      function apply() {
        var re = filter && filter !== '__photo' ? new RegExp(filter, 'i') : null, n = 0;
        cards.forEach(function (c) {
          var ok = filter === '__photo' ? c.getAttribute('data-photo') === '1' : (!re || re.test(c.textContent));
          c.classList.remove('is-more');
          if (ok) n++;
          c.classList.toggle('is-hidden', !ok || n > shown);
        });
        if (more) more.parentElement.hidden = n <= shown;
      }
      $$('.k-rv__chips button', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.k-rv__chips button', sec).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          filter = b.getAttribute('data-f'); shown = 6; apply();
        });
      });
      if (more) more.addEventListener('click', function () { shown += 9; apply(); });
      apply();
    });
  }

  /* ---------- Libellé de la formule choisie (fiche produit) ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('input[data-nk-offer]')) return;
    var scope = e.target.closest('[data-nk-buy]'); if (!scope) return;
    var n = e.target.getAttribute('data-name') || '';
    scope.querySelectorAll('[data-nk-offer-label]').forEach(function (el) { el.textContent = n; });
  });

  function init() {
    reveal(); videos(); statements(); stories(); films(); stepBars(); timelines(); counters(); accordions(); parallax(); galleryVideos(); quizzes(); preselect(); countdowns(); reviews();
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
